import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../../customs/skeleton/main";
const Main = lazy(
  () => import("../../../components/settings/certificate/certificateType/main")
);

const CertificateType = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Main />
    </Suspense>
  );
};

export default CertificateType;
